import React from 'react'

type Field = {
  key: string
  value: string | number
}
type TableProps = {
  title?: string
  fields: Field[]
  showBorder?: boolean
  fieldsStyle?: string
  titleClasses?: string
  fieldKeyClasses?: string
  fieldValueClasses?: string
}

const Table = ({
  title = '',
  fields,
  showBorder = true,
  fieldsStyle = '',
  titleClasses = 'font-GoodPro',
  fieldKeyClasses = 'font-GoodPro font-medium',
  fieldValueClasses = 'font-GoodPro'
}: TableProps) => {
  return (
    <div className='mb-6 h-fit w-full md:mb-14'>
      {!!title && (
        <h2
          className={`headline-h3 mb-4 block text-left md:mb-6 ${titleClasses}`}
        >
          {title}
        </h2>
      )}
      {fields.length > 0 && (
        <div className='flex h-fit flex-col'>
          {fields.map(
            ({ key, value }) =>
              !!key &&
              !!value && (
                <div
                  key={key}
                  className={`text-16 flex h-fit w-full flex-row items-center justify-start ${
                    showBorder ? 'border-b border-b-black' : ''
                  } ${fieldsStyle} py-2`}
                >
                  <span
                    className={`my-auto flex w-1/2 text-left tracking-[0.6px] ${fieldKeyClasses}`}
                  >
                    {key}
                  </span>
                  <span
                    className={`text-15 my-auto flex w-1/2 text-left tracking-[0.6px] ${fieldValueClasses}`}
                  >
                    {value}
                  </span>
                </div>
              )
          )}
        </div>
      )}
    </div>
  )
}

export default Table
